export const sortBy = (field, direction) => (a, b) => {
  let compareA = a;
  let compareB = b;

  if (field === "created") {
    compareA = new Date(a.created);
    compareB = new Date(b.created);
  }
  if (field === "modified") {
    compareA = new Date(a.modified);
    compareB = new Date(b.modified);
  }
  if (field === "title") {
    compareA = a.name.toUpperCase();
    compareB = b.name.toUpperCase();
  }
  if (direction === "ascending") {
    if (compareA > compareB) return 1;
    if (compareA < compareB) return -1;
    return 0;
  }
  // direction should equal descending
  if (compareA < compareB) return 1;
  if (compareA > compareB) return -1;
  return 0;
};

export const sortByCreatedDateDescending = (a, b) => {
  const aDate = new Date(a.created);
  const bDate = new Date(b.created);
  if (aDate > bDate) return -1;
  if (aDate < bDate) return 1;
  return 0;
};
export const sortByCreatedDateAscending = (a, b) => {
  const aDate = new Date(a.created);
  const bDate = new Date(b.created);
  if (aDate > bDate) return 1;
  if (aDate < bDate) return -1;
  return 0;
};
export const sortByModifiedDateDescending = (a, b) => {
  const aDate = new Date(a.modified);
  const bDate = new Date(b.modified);
  if (aDate > bDate) return -1;
  if (aDate < bDate) return 1;
  return 0;
};
export const sortByModifiedDateAscending = (a, b) => {
  const aDate = new Date(a.modified);
  const bDate = new Date(b.modified);
  if (aDate > bDate) return 1;
  if (aDate < bDate) return -1;
  return 0;
};
export const sortByTitleAscending = (a, b) => {
  const A = a.name.toUpperCase();
  const B = b.name.toUpperCase();
  if (A > B) return 1;
  if (A < B) return -1;
  return 0;
};
export const sortByTitleDescending = (a, b) => {
  const A = a.name.toUpperCase();
  const B = b.name.toUpperCase();
  if (A > B) return -1;
  if (A < B) return 1;
  return 0;
};
